/**
 * delete-comment-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class DeleteCommentRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_DELETE_COMMENT;
	public static tag : MessageTag = MessageTag.REQ_DELETE_COMMENT;

  /**
   * Construct a new {@link DeleteCommentRequest}.
   */
  constructor (
    public commentId : number
  )
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/collaboration/delete-comment-request.ts